import { render, staticRenderFns } from "./SearchSelectMenu.vue?vue&type=template&id=08bc28a3&"
import script from "./SearchSelectMenu.vue?vue&type=script&lang=js&"
export * from "./SearchSelectMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports